import { regionAPI } from './regionAPI';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRegionStates = createAsyncThunk('region/fetchRegionStates', async (payload) => {
  const response = await regionAPI.fetchRegionStates(payload);
  return response.data;
});
